import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { isRTL } = useTheme();
  const { user, saveUserLanguagePreference } = useAuth();

  const handleLanguageChange = async (lng) => {
    try {
      // Change the language in i18n
      await i18n.changeLanguage(lng);
      
      // Save the preference to the database if user is logged in
      if (user && user.uid) {
        await saveUserLanguagePreference(user.uid, lng);
      }
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  const languages = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative">
      <div className={`flex items-center bg-white border border-gray-200 rounded-md p-2 ${
        isRTL ? 'space-x-reverse space-x-2' : 'space-x-2'
      }`}>
        <span className="text-lg">{currentLanguage.flag}</span>
        <div className="flex">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`px-2 py-1 text-xs font-medium rounded transition-colors ${
                i18n.language === lang.code
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              } ${lang.code === 'ar' ? 'font-arabic' : 'font-english'}`}
            >
              {lang.code === 'en' ? 'EN' : 'ع'}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher; 